import { render, staticRenderFns } from "./ElStarRatingV2.vue?vue&type=template&id=fc7d4926"
import script from "./ElStarRatingV2.vue?vue&type=script&lang=js"
export * from "./ElStarRatingV2.vue?vue&type=script&lang=js"
import style0 from "./ElStarRatingV2.vue?vue&type=style&index=0&id=fc7d4926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports